import http from '../utils/http';

import { interpolate } from 'utils/string';
import * as endpoints from '../constants/endpoints';

export const getCustomerById = async (customerId) => {
  const { data } = await http.get(interpolate(endpoints.CUSTOMER, { customerId }));

  return data;
};

export const getCustomers = async (filters = {}) => {
  const { data } = await http.get(endpoints.CUSTOMERS, {
    params: filters,
  });

  return data;
};

/**
 * Update Customer.
 *
 * @param {string} customerId
 * @param {object} body
 *
 * @returns {object}
 */
export async function updateCustomerData(customerId, body) {
  const formattedCustomerData = formatCustomerDataForAPI(body);

  const url = interpolate(endpoints.CUSTOMER, { customerId });
  const { data } = await http.patch(url, {
    body: formattedCustomerData,
    headers: { 'content-type': 'multipart/form-data' },
  });

  return data;
}

export const formatCustomerDataForAPI = (data) => {
  const { fullName, businessName, email, phone, image } = data;
  const file = image?.[0]?.file;

  const formattedData = {
    fullName,
    businessName,
    contacts: {
      email,
      phone,
    },
  };

  if (!file) {
    formattedData.imageUrl = image?.[0]?.data_url;
  }

  if (formattedData?.image) {
    delete formattedData.image;
  }

  const form = new FormData();
  const formData = JSON.stringify(formattedData);

  form.append('file', file);
  form.append('formData', formData);

  return form;
};
